import { useEffect, useState } from 'react';
import { Input } from '@/components/ui/input';
import { Field, FieldLabel } from '@/components/ui/field';
import { useTranslation } from 'react-i18next';

export const FORM_USER_BILLING_EDIT_ID = 'form-user-billing-edit';

const initialState = {
    first_name: '',
    last_name: '',
    facturation_street: '',
    facturation_cp: '',
    facturation_city: '',
};

export default function FormUserBillingEdit({ user, onSubmit, onReset }) {
    const { t } = useTranslation();
    const [formData, setFormData] = useState(initialState);

    useEffect(() => {
        setFormData({
            first_name: user?.first_name ?? '',
            last_name: user?.last_name ?? '',
            facturation_street: user?.facturation_street ?? '',
            facturation_cp: user?.facturation_cp ?? '',
            facturation_city: user?.facturation_city ?? '',
        });
    }, [user]);

    useEffect(() => {
        if (onReset) {
            setFormData({
                first_name: user?.first_name ?? '',
                last_name: user?.last_name ?? '',
                facturation_street: user?.facturation_street ?? '',
                facturation_cp: user?.facturation_cp ?? '',
                facturation_city: user?.facturation_city ?? '',
            });
        }
    }, [onReset, user]);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!formData.first_name?.trim() || !formData.last_name?.trim()) return;
        onSubmit({
            first_name: formData.first_name.trim(),
            last_name: formData.last_name.trim(),
            facturation_street: formData.facturation_street?.trim() || undefined,
            facturation_cp: formData.facturation_cp?.trim() || undefined,
            facturation_city: formData.facturation_city?.trim() || undefined,
        });
    };

    return (
        <form
            id={FORM_USER_BILLING_EDIT_ID}
            onSubmit={handleSubmit}
            className="flex-1 overflow-y-auto px-6 py-4 space-y-5"
        >
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <Field>
                    <FieldLabel required>{t('account:prenom')}</FieldLabel>
                    <Input
                        type="text"
                        value={formData.first_name}
                        onChange={(e) => setFormData((p) => ({ ...p, first_name: e.target.value }))}
                    />
                </Field>
                <Field>
                    <FieldLabel required>{t('account:nom2')}</FieldLabel>
                    <Input
                        type="text"
                        value={formData.last_name}
                        onChange={(e) => setFormData((p) => ({ ...p, last_name: e.target.value }))}
                    />
                </Field>
            </div>

            <Field>
                <FieldLabel>{t('account:adresseDeFacturation')}</FieldLabel>
                <Input
                    type="text"
                    placeholder={t('account:rueNumero')}
                    value={formData.facturation_street}
                    onChange={(e) => setFormData((p) => ({ ...p, facturation_street: e.target.value }))}
                />
            </Field>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <Field>
                    <FieldLabel>{t('account:codePostal')}</FieldLabel>
                    <Input
                        type="text"
                        placeholder="75001"
                        value={formData.facturation_cp}
                        onChange={(e) => setFormData((p) => ({ ...p, facturation_cp: e.target.value }))}
                    />
                </Field>
                <Field>
                    <FieldLabel>{t('account:ville')}</FieldLabel>
                    <Input
                        type="text"
                        placeholder={t('account:paris')}
                        value={formData.facturation_city}
                        onChange={(e) => setFormData((p) => ({ ...p, facturation_city: e.target.value }))}
                    />
                </Field>
            </div>
        </form>
    );
}
